import { createContext, useContext } from 'react';
import { enableStaticRendering } from 'mobx-react-lite';
import CustomerDataStore from '@features/customerData/mobx/stores/CustomerDataStore';
const isServer = typeof window === 'undefined';
enableStaticRendering(isServer);
let currentStore: CustomerDataStore;
const initializeStore = () => {
  const newStore = currentStore ?? new CustomerDataStore();
  if (isServer) return newStore;
  if (!currentStore) currentStore = newStore;
  return newStore;
};
const store = initializeStore();
const CustomerDataStoreContext = createContext<CustomerDataStore>(store);
const useCustomerDataStore = () => useContext(CustomerDataStoreContext);
export { CustomerDataStore, useCustomerDataStore, store };